// extracted by mini-css-extract-plugin
module.exports = {"root":"FeatureWrapper_root__QHBt1","wrapper":"FeatureWrapper_wrapper__XS2pF","sizeWrapper":"FeatureWrapper_sizeWrapper__IjRQA"};